import { Input, InputProps } from 'components'

import FormRow, { FormRowProps } from './FormRow'
import styles from './FormRow.module.scss'

export type InputFormRowProps = FormRowProps & InputProps

const InputFormRow = ({
  className,
  description,
  link,
  mandatory,
  mode,
  title,
  ...inputProps
}: InputFormRowProps) => (
  <FormRow
    className={className}
    description={description}
    link={link}
    mandatory={mandatory}
    mode={mode}
    title={title}
  >
    <Input className={styles.input} {...inputProps} />
  </FormRow>
)

export default InputFormRow
